import {mapGetters} from "vuex";

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('app', ['currentRightsholder', 'currentRightsholderReady'])
  },
  watch: {
    currentRightsholder() {
      if (this.currentRightsholderReady) {
        this.reloadItems();
      }
    },
  },
  methods: {
    reloadItems() {
      throw new Error('Not Implemented!');
    }
  },
  mounted() {
    if (this.currentRightsholderReady) {
      this.reloadItems();
    }
  }
}